import React from 'react'

import { bool, func } from 'prop-types'

import * as S from './styled'

const Toggle = ({ opened, handleOpened }) => (
  <S.ToggleButton opened={opened} onClick={handleOpened}>
    <S.ToggleIcon viewBox="0 0 100 100">
      <S.ToggleBar d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20" />
      <S.ToggleBar d="m 70,50 h -40" />
      <S.ToggleBar d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20" />
    </S.ToggleIcon>
  </S.ToggleButton>
)

Toggle.defaultProps = {
  opened: false,
  handleOpened: () => {},
}

Toggle.propTypes = {
  opened: bool,
  handleOpened: func,
}

export default Toggle
